/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Statistics_Correlation_TitleInputs */

const en_admin_statistics_correlation_title = /** @type {(inputs: Admin_Statistics_Correlation_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Matching score & interview invitations`)
};

const de_admin_statistics_correlation_title = /** @type {(inputs: Admin_Statistics_Correlation_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Matching Score & Gesprächseinladungen`)
};

/**
* | output |
* | --- |
* | "Matching score & interview invitations" |
*
* @param {Admin_Statistics_Correlation_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_statistics_correlation_title = /** @type {((inputs?: Admin_Statistics_Correlation_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Statistics_Correlation_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_statistics_correlation_title(inputs)
	return en_admin_statistics_correlation_title(inputs)
});